export default __webpack_public_path__ + "static/media/home2_bg.a0742a29.png";